<template>
  <div>
    <div v-if="$permission.canWrite()" class="navbar-group">
      <!-- <el-button type="primary" @click="extract">提取数据</el-button> -->
      <el-dropdown>
        <el-button type="primary" class="menu">
          提取数据<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown" style="margin-left: 4px">
          <el-dropdown-item class="dropdown-item" @click.native="extract(0)"
            >提取存货分类</el-dropdown-item
          >
          <el-dropdown-item class="dropdown-item" @click.native="extract(1)"
            >提取客户数据</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
      <el-button type="primary" @click="edit">批量修改</el-button>
      <el-button type="primary" @click="save">保存</el-button>
      <el-button type="primary" @click="delRows">删除</el-button>
      <el-button type="primary" @click="find">查找</el-button>
      <el-button type="success" plain @click="onImprot">导入</el-button>
      <el-button type="success" @click="onExport">导出</el-button>
      <el-button type="primary" @click="openPrint">打印</el-button>
    </div>
    <!-- @row-click="addColumn" -->
    <el-table
      border
      :data="tableList"
      class="tableList"
      tooltip-effect="dark"
      :row-class-name="tableRowClassName"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" align="center" width="55" />
      <el-table-column
        prop="TradeUnitNo"
        label="客户编码"
        align="center"
        min-width="180px"
      />
      <el-table-column
        prop="FullName"
        label="客户名称"
        align="center"
        min-width="150px"
      />
      <el-table-column
        prop="ShortName"
        label="客户简称"
        align="center"
        min-width="150px"
      />
      <el-table-column prop="ProductClassNo" label="存货分类编码" align="center" />
      <el-table-column
        prop="ProductClassName"
        label="存货分类名称"
        min-width="120px"
        align="center"
      />

      <!-- <el-table-column prop="SaUnitName" label="计量单位" align="center" /> -->
      <el-table-column prop="DiscountRate" label="折扣率" align="center" v-if="canPrice">
        <template slot-scope="{ row }">
          <el-input
            type="number"
            v-model.number="row.DiscountRate"
            @change="changT(row)"
          />
        </template>
      </el-table-column>
      <el-table-column prop="FinalPrice" label="成交价" align="center" v-if="canPrice">
        <template slot-scope="{ row }">
          <el-input
            type="number"
            v-model.number="row.FinalPrice"
            @change="changT(row)"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="Remark"
        label="备注"
        align="center"
        min-width="200px"
      >
        <template slot-scope="{ row }">
          <el-input
            type="textarea"
            v-model="row.Remark"
            :autosize="{ minRows: 1, maxRows: 2 }"
            maxlength="50"
            show-word-limit
            @change="changT(row)"
          />
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
      background
      style="margin-top: 5px; float: right"
      :page-size.sync="pageParams.pageSize"
      :page-sizes="[10, 20, 50]"
      :current-page.sync="pageParams.pageIndex"
      layout="sizes, prev, pager, next, total, jumper"
      :total="total"
      @size-change="onPageSizeChange"
      @current-change="onPageIndexChange"
    />
    <edit-dialog ref="editDialog" @close-saved="reload"></edit-dialog>
    <extract-dialog ref="extractDialog" @close-saved="reload"></extract-dialog>
    <find-dialog ref="findDialog" @close-saved="reload"></find-dialog>

    <import-dialog ref="importDialog" @upload-success="reload" />
    <print-dialog
      ref="printDialog"
      :columns="columns"
      :data="columnData"
      :form-data="formData"
    ></print-dialog>
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import editDialog from "@/components/business/sales/salemanage/inventorycategory/editDialog";
import extractDialog from "@/components/business/sales/salemanage/inventorycategory/extractDialog";
import findDialog from "@/components/business/sales/salemanage/inventorycategory/findDialog";
import list from "@/components/business/sales/salemanage/inventorycategory/list";
import printDialog from "@/components/common/printDialog/printDialog";
import importDialog from "@/components/business/sales/salemanage/inventorycategory/importDialog";
import accountSelect from "@/components/production/clothmanagement/cloth/select";
import salePriceList from "@/data/business/sales/salemanage/inventorycategory/edit/list.json";
export default {
  name: "inventorycategory",
  mixins: [curdMixins],
  components: {
    list,
    extractDialog,
    findDialog,
    editDialog,
    importDialog,
    accountSelect,
    printDialog,
  },
  data() {
    return {
      api: require("@/api/sa/saClassCustomer").default,
      pdApi: require("@/api/ba/product").default,
      page: false,
      total: 0,
      formData: [],
      columnkey: [],
      columns: [],
      columnData: [],
      tableList: [],
      multipleSelection: [],
      initDAccount: [],
      initTotal: 0,
      DAccount: [],
      listTotal: 0,
      pageParams: {
        pageSize: 10, //分页大小
        pageIndex: 1,
      },
    };
  },
  computed: {
    canPrice() {
      return this.$permission.canPrice();
    },
  },
  mounted() {
    this.pdApi.list({ Property: "销售" }).then((res) => {
      this.DAccount = res.Data;
      this.initDAccount = res.Data;
      this.listTotal = res.Count;
      this.initTotal = res.Count;
    });
    this.findList();
  },
  methods: {
    changT(row) {
      if (row.T == 3) row.T = 1;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log("multipleSelection", this.multipleSelection);
    },
    findList(param = null) {
      let params = {};
      if(param === null) params = this.pageParams;
      else {
        params = { ...param, pageSize: this.pageParams.pageSize, pageIndex: 1 };
        this.pageParams = params;
      }
      this.api.list(params).then((res) => {
        if (res.Code === 0) {
          // this.tableList = res.Data.map((i) => ((i.isEdit = false), i));
          this.total = res.Count;
          this.tableList = res.Data.map((i) => {
            i.T = 3;
            return i;
          });
        }
      });
    },
    save() {
      // console.log(object);
      if (this.tableList.filter((i) => i.T != 3).length === 0)
        return this.$message.warning("没有新增数据");
      let data = this.tableList.filter((i) => i.T != 3);
      this.api.save(data).then((res) => {
        if (res.Code === 0) {
          this.$message.success(res.Msg);
          this.api.list({}).then((res) => {
            if (res.Code == 0) this.findList();
          });
        }
        if (res.Code === 1) this.$message.error(res.Msg);
      });
    },
    // 批量修改
    edit() {
      let rows = this.multipleSelection;
      if (rows.length == 0) {
        this.$message.warning("请选择要修改的数据");
        return;
      }
      console.log("rows", rows);
      let ids = rows.map((item) => {
        return item.ClassCustomerId;
      });
      return this.$refs.editDialog.open(ids);
    },

    // 查找
    find() {
      const row = this.tableList.filter((i) => {
        return i.T == 1;
      });
      if (row.length > 0) {
        return this.$confirm("已修改是否保存", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          let data = this.tableList.filter((i) => i.T != 3);
          // data = this.$commonJs.obj.removeNullKey(data);
          this.api.save(data).then((res) => {
            if (res.Code == 0) {
              this.$refs.findDialog.open();
              this.$message.success(res.Msg);
            }
            if (res.Code == 1) this.$message.error(res.Msg);
          });
        });
      }

      return this.$refs.findDialog.open();

      // return this.$message.warning('未发现有数据修改')
    },
    // 提取数据
    extract(data) {
      this.$refs.extractDialog.open(data);
    },

    // 导入
    onImprot() {
      this.$refs.importDialog.open();
    },
    // 导出
    onExport(params = {}) {
      this.$confirm("是否导出数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // this.$refs.list.onExport(params);
          var loading = this.$loading({
            lock: true,
            text: "正在导出...",
            spinner: "el-icon-loading",
            customClass: "my_loading",
            background: "rgba(0, 0, 0, 0.3)",
          });
          this.api.export(params).then(() => {
            loading.close();
          });
        })
        .catch(() => {});
    },
    // 删除
    delRows() {
      // let rows = this.multipleSelection.filter((i) => i.ClassCustomerId != 0);
      let rows = this.multipleSelection;
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let ids = rows.map((item) => {
          return item.ClassCustomerId;
        });
        this.api.delete({ ids }).then((res) => {
          if (res.Code === 0) {
            this.$message.success(res.Msg);
            this.findList();
          } else this.$message.error(res.Msg);
        });
      });
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex;
    },

    openPrint() {
      console.log("salePriceList", salePriceList);
      this.columnkey = salePriceList.Data.map((i) => i.tableName);
      this.columns = salePriceList.Data.reduce((acc, item) => {
        let print = { ...item.print, key: item.tableName, label: item.label };
        acc.push({ label: item.label, data: print });
        return acc;
      }, []);
      this.formData = salePriceList.Data.reduce((acc, item) => {
        return acc.concat({
          key: item.tableName,
          label: item.label,
          value: this.tableList[item.tableName],
        });
      }, []);

      this.$refs.printDialog.open();
    },
    //分页容量大小发生变化时
    onPageSizeChange(value) {
      this.pageParams.pageSize = value;
      this.findList();
    },
    //
    onPageIndexChange(pageIndex) {
      this.pageParams.pageIndex = pageIndex;
      this.findList();
    },
    resetFun() {
      this.pageParams.pageIndex = 1;
      this.DAccount = this.initDAccount;
      this.listTotal = this.initTotal;
    },
    currentPage(val) {
      this.pageParams.pageIndex = val;
      this.pdApi
        .list({ Property: "销售", pageIndex: val, pageSize: 7 })
        .then((res) => {
          if (res.Code == 0) {
            this.DAccount = res.Data;
            this.listTotal = res.Count;
          }
        });
    },
    inputText(text) {
      this.pdApi
        .list({
          Property: "销售",
          pageIndex: 1,
          pageSize: 7,
          ProductClassName: text,
        })
        .then((res) => {
          if (res.Code == 0) {
            this.DAccount = res.Data;
            this.listTotal = res.Count;
          }
        });
    },
    // 选择存货名称
    onSelect(e, row) {
      console.log("e", e);
      let Product = this.tableList.map((i) => i.ProductId);
      if (Product.includes(e.ProductId))
        return this.$message.warning("产品已存在");

      row.ClassName = e.ClassName;
      row.TradeUnitClassNo = e.TradeUnitClassNo;
      row.TradeUnitClassName = e.TradeUnitClassName;
      row.ProductClassName = e.ProductClassName;
      row.SaUnitName = e.SaUnitName;
      row.ProductId = e.ProductId;
      row.ProductSpec = e.ProductSpec;
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .navbar-group {
  margin-bottom: 20px;
  text-align: right;
  .el-button {
    margin-left: 4px;
  }
}

.not-edit {
  display: inline-block;
  min-width: 190px;
  text-align: center;
  // border-bottom: 1px solid #e4e7ed;
}

.dropdown-item {
  padding: 5px 10px;
}

// /deep/ .tableList .el-select .el-input__inner {
//   border: none;
//   border-bottom: 1px solid #e4e7ed;
// }
</style>
